module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Fog-89977e58322928ef58c9227b1250ddf8.svg";